module.exports = __webpack_public_path__ + "static/media/kontakt-ergotherapie-soest-annegret-baumheier-praxis.21b2980f.jpg";